(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["administrador-lista-precios"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var app=document.querySelector('[data-lp-app]');if(!app)return;
    var rows=[].slice.call(app.querySelectorAll('[data-lp-row]')),changes=new Map();
    var search=app.querySelector('[data-lp-search]'),filter=app.querySelector('[data-lp-filter]'),count=app.querySelector('[data-lp-change-count]'),summary=app.querySelector('[data-lp-summary]'),submit=app.querySelector('[data-lp-submit]'),noResults=app.querySelector('[data-lp-no-results]');
    function money(n){return Number(n||0).toLocaleString('es-UY',{minimumFractionDigits:2,maximumFractionDigits:2});}
    function refreshRow(row){var price=row.querySelector('[data-lp-price]'),available=row.querySelector('[data-lp-available]');var original=Number(row.dataset.originalPrice),originalAvailable=row.dataset.available==='true';var changed=Math.abs(Number(price.value)-original)>.001||available.checked!==originalAvailable;row.classList.toggle('is-changed',changed);row.querySelector('[data-lp-row-status]').textContent=changed?'Pendiente':'Sin cambios';if(changed){changes.set(row.dataset.variant,{variant_id:row.dataset.variant,product:row.dataset.product,old_price:original,new_price:Number(price.value),available:available.checked});}else changes.delete(row.dataset.variant);refreshSummary();applyFilter();}
    function refreshSummary(){var size=changes.size;count.textContent=size?size+' cambio'+(size===1?'':'s')+' pendiente'+(size===1?'':'s'):'Sin cambios pendientes';summary.textContent=size?'Preparaste '+size+' modificación'+(size===1?'':'es'):'Tu lista está al día';submit.disabled=!size;}
    function applyFilter(){var q=(search&&search.value||'').trim().toLowerCase(),f=filter?filter.value:'all',visible=0;rows.forEach(function(row){var ok=(!q||row.dataset.search.indexOf(q)>-1)&&(f==='all'||(f==='available'&&row.querySelector('[data-lp-available]').checked)||(f==='unavailable'&&!row.querySelector('[data-lp-available]').checked)||(f==='changed'&&row.classList.contains('is-changed')));row.hidden=!ok;if(ok)visible++;});if(noResults)noResults.hidden=visible!==0;}
    rows.forEach(function(row){row.querySelectorAll('input').forEach(function(input){input.addEventListener('change',function(){refreshRow(row)});input.addEventListener('input',function(){refreshRow(row)});});});
    if(search)search.addEventListener('input',applyFilter);if(filter)filter.addEventListener('change',applyFilter);
    function csvEscape(v){v=String(v==null?'':v);return /[",\n]/.test(v)?'"'+v.replace(/"/g,'""')+'"':v;}
    function download(filename,items){var lines=['variant_id,producto,precio_actual,nuevo_precio,disponible'];items.forEach(function(x){lines.push([x.variant_id,x.product,x.old_price,x.new_price,x.available?'si':'no'].map(csvEscape).join(','));});var blob=new Blob(['\ufeff'+lines.join('\n')],{type:'text/csv;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=filename;document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);}
    var exportButton=app.querySelector('[data-lp-export]');if(exportButton)exportButton.addEventListener('click',function(){var all=rows.map(function(row){return{variant_id:row.dataset.variant,product:row.dataset.product,old_price:row.dataset.originalPrice,new_price:row.querySelector('[data-lp-price]').value,available:row.querySelector('[data-lp-available]').checked};});download('lista-'+(app.dataset.brand||'marca').toLowerCase().replace(/[^a-z0-9]+/g,'-')+'.csv',all);});
    var importer=app.querySelector('[data-lp-import]');if(importer)importer.addEventListener('change',function(){var file=importer.files&&importer.files[0];if(!file)return;var reader=new FileReader();reader.onload=function(){var lines=String(reader.result||'').replace(/^\ufeff/,'').split(/\r?\n/),headers=(lines.shift()||'').split(',').map(function(v){return v.trim().toLowerCase()}),idIndex=headers.indexOf('variant_id'),priceIndex=headers.indexOf('nuevo_precio'),availableIndex=headers.indexOf('disponible');if(idIndex<0||priceIndex<0){alert('El CSV debe incluir las columnas variant_id y nuevo_precio.');return;}lines.forEach(function(line){var values=line.split(','),row=app.querySelector('[data-variant="'+String(values[idIndex]||'').trim()+'"]');if(!row)return;var price=Number(String(values[priceIndex]||'').replace(',','.'));if(!isNaN(price))row.querySelector('[data-lp-price]').value=price;if(availableIndex>-1){var value=String(values[availableIndex]||'').trim().toLowerCase();row.querySelector('[data-lp-available]').checked=['si','sí','true','1'].indexOf(value)>-1;}refreshRow(row);});};reader.readAsText(file);});
    if(submit)submit.addEventListener('click',function(){if(!changes.size)return;var items=Array.from(changes.values()),brand=app.dataset.brand||'mi marca';download('actualizacion-pendiente-'+brand.toLowerCase().replace(/[^a-z0-9]+/g,'-')+'.csv',items);var text='Hola ReponGo, envié una actualización de la lista de '+brand+' con '+items.length+' cambio'+(items.length===1?'':'s')+'. Adjunto el archivo descargado desde el portal.';window.open('https://wa.me/'+app.dataset.support+'?text='+encodeURIComponent(text),'_blank');});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compras-colectivas-demo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-demo]').forEach(function(root) {
    var minus = root.querySelector('[data-cc-minus]');
    if (!minus) return;
    var qty = 1;
    var price = Number(root.dataset.unitPrice || 0);
    var qtyText = root.querySelector('[data-cc-qty]');
    var totalText = root.querySelector('[data-cc-total]');
    var form = root.querySelector('[data-cc-form]');
    var result = root.querySelector('[data-cc-result]');
    var resultCopy = root.querySelector('[data-cc-result-copy]');
    var submit = root.querySelector('[data-cc-submit]');
    var sending = false;
    function money(value) { return '$' + value.toLocaleString('es-UY', { maximumFractionDigits: 0 }); }
    function render() { qtyText.textContent = qty; qtyText.nextElementSibling.textContent = qty === 1 ? 'caja' : 'cajas'; totalText.textContent = money(price * qty); }
    minus.addEventListener('click', function() { qty = Math.max(1, qty - 1); render(); });
    root.querySelector('[data-cc-plus]').addEventListener('click', function() { qty = Math.min(20, qty + 1); render(); });
    submit.addEventListener('click', function() {
      if (sending) return;
      var payment = root.querySelector('input[name="cc-payment"]:checked');
      var terms = root.querySelector('[data-cc-terms]');
      if (!payment) { alert('Elegí una forma de confirmación.'); return; }
      if (!terms.checked) { alert('Confirmá que entendés cómo funciona la participación.'); return; }
      if (root.dataset.designMode === 'true') {
        resultCopy.textContent = 'Vista del editor: ' + qty + (qty === 1 ? ' caja' : ' cajas') + ' mediante ' + payment.value + '. Total estimado: ' + money(price * qty) + '. No se creó ningún registro.';
        form.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      sending = true;
      var original = submit.innerHTML;
      submit.disabled = true;
      submit.innerHTML = '<span>Registrando interés…</span>';
      fetch('/apps/repongo-repos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          request_type: 'collective_interest',
          campaign_code: root.dataset.campaignCode,
          campaign_name: root.dataset.campaignName,
          supplier: root.dataset.supplier,
          deadline: root.dataset.deadline,
          quantity: qty,
          unit_price: price,
          payment_method: payment.value
        })
      }).then(function(response) {
        return response.json().catch(function() { throw new Error('El servidor no devolvió una respuesta válida.'); }).then(function(data) {
          if (!response.ok || !data.ok) throw new Error(data.error || 'No se pudo registrar el interés.');
          return data;
        });
      }).then(function(data) {
        resultCopy.textContent = 'Solicitaste ' + qty + (qty === 1 ? ' caja' : ' cajas') + ' mediante ' + payment.value + '. Total estimado: ' + money(price * qty) + '. Registro ' + (data.draft_order_name || 'creado') + '.';
        form.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function(error) {
        alert('No pudimos registrar tu interés.\n\n' + error.message + '\n\nIntentá nuevamente.');
      }).finally(function() {
        sending = false;
        submit.disabled = false;
        submit.innerHTML = original;
      });
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-home-canal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rg-message]').forEach(function (box) {
    var messages = [
      'Tu comercio convierte cercanía en confianza.',
      'Cada producto disponible puede resolverle el día a un vecino.',
      'Tu comercio es una parte activa de la vida del barrio.',
      'Reponer a tiempo también es cuidar a tus clientes.'
    ];
    var text = box.querySelector('p');
    if (text) text.textContent = messages[Math.floor(Math.random() * messages.length)];
  });

  document.querySelectorAll('[data-rg-brands]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-rg-brands-track]');
    var prev = carousel.querySelector('[data-rg-brands-prev]');
    var next = carousel.querySelector('[data-rg-brands-next]');
    if (!track) return;
    function step(direction) {
      var card = track.querySelector('.rg-brand-card');
      var distance = card ? card.getBoundingClientRect().width + 13 : 183;
      track.scrollBy({ left: direction * distance * 3, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var timer = window.setInterval(function () {
      if (track.matches(':hover') || document.hidden) return;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var card = track.querySelector('.rg-brand-card');
      var distance = card ? card.getBoundingClientRect().width + 13 : 225;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + distance, behavior: 'smooth' });
    }, 3500);
    carousel.addEventListener('shopify:section:unload', function () { window.clearInterval(timer); });
  });

  } catch(e) { console.error(e); }
})();
})();
